import React, { useState, useEffect } from "react"
import {
  Col,
  Card,
  Nav,
  CardBody,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Table,
  Row,
} from "reactstrap"
import classnames from "classnames"
import { SuccessOk } from "configs/statusCode";
import CompoundService from "services/Admin/CompoundService"
import { AvForm, AvField } from 'availity-reactstrap-validation'
import ReactApexChart from "react-apexcharts"
import DashboardService from "services/Admin/DashboardService"
import Select from "react-select"

const cardsTypes = ["deals", "leads", "resales"]

const Transactions = ({ setActiveChart, units }) => {
  const compoundService = new CompoundService()
  const dashboardService = new DashboardService()
  const [dashboardData, setDashboardData] = useState(null)
  const [month, setMonth] = useState("")
  const [activeTab, setactiveTab] = useState("1")
  const [labels, setLabels] = useState(["Deals", "Leads"])
  const [compoundOpttions, setCompoundOptions] = useState([])
  const [compounds, setCompounds] = useState(null)
  const [options, setOptions] = useState(null)

  useEffect(() => {
    cardsTypes.map(item => {
      let data = {
        [`${item}`]: 1
      }
      if (month.length) data["date"] = month
      dashboardService.getList(data).then((res) => {
        if (res && res.status === SuccessOk) {
          setDashboardData(data => ({
            ...data,
            ...res.data
          }))
        }
      })
    })
  }, [month]);
  useEffect(() => {
    let data = {
      compoundUnits: 1
    }
    if (month.length) data["date"] = month
    if (compounds ?.length) data["compound_ids"] = compounds ?.map(compound => compound.value).join("-")
      dashboardService.getList(data).then((res) => {
      if (res && res.status === SuccessOk) {
        setDashboardData(data => ({
          ...data,
          ...res.data
        }))
        setOptions(res.data)
      }
    })
  }, [compounds, month]);

  useEffect(() => {
    compoundService.getDropDown().then(response => {
      const newOptions = response.data.map(item => {
        return {
          label: item.name.en,
          value: item.id
        }
      })
      setCompoundOptions(newOptions)
    })
  }, [])

  useEffect(() => {
    setActiveChart(activeTab)
  }, [activeTab])

  useEffect(() => {
    setDashboardData(data => ({ ...data, totalUnits: units }))
  }, [units])

  const walletOptions = {
    plotOptions: {
      radialBar: {
        offsetY: 0,
        startAngle: 0,
        endAngle: 270,
        hollow: {
          margin: 5,
          size: activeTab === "3" ? "25%" : "50%",
          background: "transparent",
          image: void 0,
        },
        track: {
          show: !0,
          startAngle: void 0,
          endAngle: void 0,
          background: "#f2f2f2",
          strokeWidth: "97%",
          opacity: 1,
          margin: 12,
          dropShadow: {
            enabled: !1,
            top: 0,
            left: 0,
            blur: 3,
            opacity: 0.5,
          },
        },
        dataLabels: {
          name: {
            show: !0,
            fontSize: "16px",
            fontWeight: 600,
            offsetY: -10,
          },
          value: {
            show: !0,
            fontSize: "14px",
            offsetY: 4,
            formatter: function (e) {
              return e + "%"
            },
          },
          total: {
            show: !0,
            label: activeTab === "3" ? "Total Resales" : "Total Units",
            color: "#373d3f",
            fontSize: "16px",
            fontFamily: void 0,
            fontWeight: 600,
            formatter: function (e) {
              return activeTab === "3" ? `${dashboardData ?.resales ?.pending + dashboardData ?.resales ?.live + dashboardData ?.resales ?.rejected + dashboardData ?.resales ?.sold}`
                : `${dashboardData ?.totalUnits ? dashboardData ?.totalUnits : 0}`
            },
          },
        },
      },
    },
    stroke: {
      lineCap: "round",
    },
    colors: activeTab === "3" ? ["#2ca67a", "#FF0000", "#0DCAF0", "#F7D71A"] : ["#3452e1", "#f1b44c", "#50a5f1"],
    labels: labels,
    legend: { show: !1 },
  }

  const compoundChartOptions = {
    plotOptions: {
      radialBar: {
        offsetY: 0,
        startAngle: 0,
        endAngle: 270,
        hollow: {
          margin: 5,
          size: activeTab === "3" ? "25%" : "50%",
          background: "transparent",
          image: void 0,
        },
        track: {
          show: !0,
          startAngle: void 0,
          endAngle: void 0,
          background: "#f2f2f2",
          strokeWidth: "97%",
          opacity: 1,
          margin: 12,
          dropShadow: {
            enabled: !1,
            top: 0,
            left: 0,
            blur: 3,
            opacity: 0.5,
          },
        },
        dataLabels: {
          name: {
            show: !0,
            fontSize: "16px",
            fontWeight: 600,
            offsetY: -10,
          },
          value: {
            show: !0,
            fontSize: "14px",
            offsetY: 4,
            formatter: function (e) {
              return e + "%"
            },
          },
          total: {
            show: !0,
            label: activeTab === "3" ? "Total Resales" : "Total Units",
            color: "#373d3f",
            fontSize: "16px",
            fontFamily: void 0,
            fontWeight: 600,
            formatter: function (e) {
              return `${options ?.compoundUnits ?.boughtUnits + options ?.compoundUnits ?.leftUnits}`
            },
          },
        },
      },
    },
    stroke: {
      lineCap: "round",
    },
    colors: activeTab === "3" ? ["#2ca67a", "#FF0000", "#0DCAF0", "#F7D71A"] : ["#3452e1", "#f1b44c", "#50a5f1"],
    labels: labels,
    legend: { show: !1 },
  }

  return (
    <React.Fragment>
      <Col>
        <Card style={{ minHeight: activeTab === "2" ? "96.8vh" : "90vh" }}>
          <CardBody>
            <Row className="mb-0">
              <Col md={6} className="pt-3">
                <h4 className="card-title mb-4">Statistics</h4>
              </Col>
              <Col md={6} className="d-flex justify-content-end"  >
                <AvForm>
                  <AvField
                    name={"date"}
                    bsSize="lg"
                    value={month}
                    onChange={e => setMonth(e.target.value)}
                    type="month"
                  />
                </AvForm>
              </Col>
            </Row>
            <Nav pills className="bg-light rounded" role="tablist">
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "1" })}
                  onClick={() => {
                    setactiveTab("1")
                    setLabels(["Deals", "Leads"])
                  }}
                >
                  All
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => {
                    setactiveTab("2")
                    setLabels(["Bought Units", "Left Units"])
                  }}
                >
                  Compound
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "3" })}
                  onClick={() => {
                    setactiveTab("3")
                    setLabels(["Live", "Rejected", "Pending", "Sold"])
                  }}
                >
                  Resale
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab} className="mt-4">
              <TabPane tabId="1">
                <div>
                  <Row>

                    <Col sm="12">
                      <div className="mx-auto">
                        <div id="wallet-balance-chart">
                          {dashboardData ?.totalUnits ? <ReactApexChart
                            options={walletOptions}
                            series={[dashboardData ?.deals ?.percentage ? dashboardData ?.deals ?.percentage : 0 , dashboardData ?.leads ?.percentage ? dashboardData ?.leads ?.percentage : 0]}
                            type="radialBar"
                            height={300}
                            className="apex-charts"
                          /> : null}
                        </div>
                      </div>
                    </Col>
                    <Row className="d-flex justify-content-around">
                      <Col sm="12" lg={4} className="align-self-center">
                        <div className="mt-4 pt-2 ">
                          <p className="mb-2">
                            <i className="mdi mdi-circle align-middle font-size-10 me-2 text-primary" />{" "}
                            Deals {dashboardData ?.deals ?.percentage}%
                        </p>
                          <h5>
                            <span className=" font-size-14 align-subInfo-admin">{dashboardData ?.deals ?.unitsCount} Units Count</span>
                          </h5>
                        </div>
                      </Col>
                      <Col sm="12" lg={4} className="align-self-center">
                        <div className="mt-4 pt-2  ">
                          <p className="mb-2">
                            <i className="mdi mdi-circle align-middle font-size-10 me-2 text-warning" />{" "}
                            Leads {dashboardData ?.leads ?.percentage}%
                        </p>
                          <h5>
                            <span className=" font-size-14 align-subInfo-admin">{dashboardData ?.leads ?.leadsCount} Leads Count</span>
                          </h5>
                        </div>
                      </Col>
                    </Row>

                  </Row>
                </div>
              </TabPane>
              <TabPane tabId="2">
                <div>
                  <Row>

                    <Col md={6}  ></Col>
                    <Col md={6}  >
                      <label>Compound Name</label>
                      <Select
                        label='Compound '
                        placeholder='Select'
                        options={compoundOpttions}
                        className='mb-3 '
                        onChange={(data) => setCompounds(data)}
                        value={compounds}
                        isMulti={true}
                      />
                    </Col>
                    <div className="mx-auto">
                      <div id="wallet-balance-chart">
                        {dashboardData ?.totalUnits ? <ReactApexChart
                          options={compoundChartOptions}
                          series={[
                            dashboardData ?.compoundUnits ?.boughtUnitsPercentage ? dashboardData ?.compoundUnits ?.boughtUnitsPercentage : 0  ,
                            dashboardData ?.compoundUnits ?.leftUnitsPercentage ? dashboardData ?.compoundUnits ?.leftUnitsPercentage : 0 ]}
                          type="radialBar"
                          height={300}
                          className="apex-charts"
                        /> : null}
                      </div>
                    </div>
                    <Row className="d-flex justify-content-around">
                      <Col sm="12" lg={4} className="align-self-center">
                        <div className="mt-4 pt-2 ">
                          <p className="mb-2">
                            <i className="mdi mdi-circle align-middle font-size-10 me-2 text-primary" />{" "}
                            Bought {dashboardData ?.compoundUnits ?.boughtUnitsPercentage}%
                        </p>
                          <h5>
                            <span className=" font-size-14 align-subInfo-admin">{dashboardData ?.compoundUnits ?.boughtUnits} Unit</span>
                          </h5>
                        </div>
                      </Col>
                      <Col sm="12" lg={4} className="align-self-center">
                        <div className="mt-4 pt-2 ">
                          <p className="mb-2">
                            <i className="mdi mdi-circle align-middle font-size-10 me-2 " style={{ color: "#f1b44c" }} />{" "}
                            Left {dashboardData ?.compoundUnits ?.leftUnitsPercentage}%
                        </p>
                          <h5>
                            <span className=" font-size-14 align-subInfo-admin">{dashboardData ?.compoundUnits ?.leftUnits} Unit</span>
                          </h5>
                        </div>
                      </Col>
                    </Row>
                  </Row>
                </div>
              </TabPane>

              <TabPane tabId="3">
                <div>
                  <Row>

                    <Col sm="12">
                      <div className="mx-auto">
                        <div id="wallet-balance-chart">
                          {dashboardData ?.totalUnits ? <ReactApexChart
                            options={walletOptions}
                            series={[
                              dashboardData ?.resales ?.livePercentage ? dashboardData ?.resales ?.livePercentage : 0 ,
                              dashboardData ?.resales ?.rejectedPercentage ? dashboardData ?.resales ?.rejectedPercentage : 0  ,
                              dashboardData ?.resales ?.pendingPercentage ? dashboardData ?.resales ?.pendingPercentage : 0 ,
                              dashboardData ?.resales ?.soldPercentage ? dashboardData ?.resales ?.soldPercentage : 0
                           ]}
                            type="radialBar"
                            height={300}
                            className="apex-charts"
                          /> : null}
                        </div>
                      </div>
                    </Col>
                    <Row className="d-flex justify-content-around px-5">
                      <Col sm="12" lg={3} className="align-self-center">
                        <div className="mt-4 pt-2 ">
                          <p className="mb-2">
                            <i className="mdi mdi-circle align-middle font-size-10 me-2" style={{ color: "#2ca67a" }} />{" "}
                            Live {dashboardData ?.resales ?.livePercentage}%
                        </p>
                          <h5>
                            <span className=" font-size-14 align-subInfo-admin">{
                              dashboardData ?.resales ?.live  
                          } Unit</span>
                          </h5>
                        </div>
                      </Col>
                      <Col sm="12" lg={3} className="align-self-center">
                        <div className="mt-4 pt-2 ">
                          <p className="mb-2">
                            <i className="mdi mdi-circle align-middle font-size-10 me-2" style={{ color: "#FF0000" }} />{" "}
                            Rejected {dashboardData ?.resales ?.rejectedPercentage}%
                        </p>
                          <h5>
                            <span className=" font-size-14 align-subInfo-admin">{dashboardData ?.resales ?.rejected} Unit</span>                        </h5>
                        </div>
                      </Col>
                      <Col sm="12" lg={3} className="align-self-center">
                        <div className="mt-4 pt-2 ">
                          <p className="mb-2">
                            <i className="mdi mdi-circle align-middle font-size-10 me-2" style={{ color: "#0DCAF0" }} />{" "}
                            Pending {dashboardData ?.resales ?.pendingPercentage}%
                        </p>
                          <h5>
                            <span className=" font-size-14 align-subInfo-admin">{dashboardData ?.resales ?.pending} Unit</span>                        </h5>
                        </div>
                      </Col>
                      <Col sm="12" lg={3} className="align-self-center">
                        <div className="mt-4 pt-2 ">
                          <p className="mb-2">
                            <i className="mdi mdi-circle align-middle font-size-10 me-2" style={{ color: "#F7D71A" }} />{" "}
                            Sold {dashboardData ?.resales ?.soldPercentage}%
                        </p>
                          <h5>
                            <span className=" font-size-14 align-subInfo-admin">{dashboardData ?.resales ?.sold  } Unit</span>                        </h5>
                        </div>
                      </Col>
                    </Row>

                  </Row>
                </div>
              </TabPane>
            </TabContent>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  )
}


export default Transactions
